module.exports = __webpack_public_path__ + "media/images/connect_ad_logo-20f4228fa2ab271f1b2aaa67111aae63.png";